import { render, staticRenderFns } from "./DashboardConsultoria.vue?vue&type=template&id=51882bfe"
import script from "./DashboardConsultoria.vue?vue&type=script&lang=js"
export * from "./DashboardConsultoria.vue?vue&type=script&lang=js"
import style0 from "./DashboardConsultoria.vue?vue&type=style&index=0&id=51882bfe&prod&scope=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VProgressCircular,VRow})
